import React from 'react';
import './Footer.css';
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    // <footer className="footer">
    
    //   <div className="footer-bottom">
    //     <div className="footer-bottom-content">
    //         <div className="footer-logo">
    //           <img src='latentlogo.png'  alt="Process Intelligence" />
    //         </div>
    //       <p className="footer-copyright">
    //         © {currentYear} Process Intelligence. All rights reserved.
    //       </p>
        
    //     </div>
    //   </div>
    // </footer>
    <></>
  );
};

export default Footer; 